import { DocumentationFilterInputObject } from 'graphql-common';
import createSearchFilters from '@lib/utils/createSearchFilters';

const SEARCH_FIELDS = [
  { fieldName: 'name' },
  { fieldName: 'code' },
  { fieldName: 'categoryName' },
  { fieldName: 'tagsName' },
];

/**
 * Builds the GraphQL filter array for a free-text search against a document's
 * name / code / category name / tag names. Returns an empty array when the
 * query is empty so the caller can omit the parameter entirely.
 */
export default function buildSearchFilters(
  searchQuery: string,
): DocumentationFilterInputObject[] {
  if (!searchQuery) return [];
  return createSearchFilters(
    searchQuery,
    SEARCH_FIELDS,
  ) as DocumentationFilterInputObject[];
}
